import { TextField, TextFieldProps } from "@mui/material"
import { Autocomplete, fieldToTextField } from "formik-mui"
import { SelectOption } from "../../data/selectInput.type";

export const FormikAutocomplete = ({ textFieldProps, ...props }:  any & TextFieldProps) => {
  const {
    form: { setFieldTouched, setFieldValue }
  } = props;

  const { error, helperText, ...field } = fieldToTextField(props);
  const { name } = field as {name: string};

  return (
    <Autocomplete
      {...props}
      {...field}
      onChange={(_, option: SelectOption) => setFieldValue(name, option)}
      onBlur={() => setFieldTouched(name)}
      getOptionLabel={(selected: SelectOption) => {
        const obj = props.options.find((option:SelectOption) => {
          return option.value === selected.value
        });

        if (obj) {
          return obj.label
        } else {
          return '';
        }
      }}
      disablePortal
      isOptionEqualToValue={(option: SelectOption, value: SelectOption) => value && option.value === value.value}
      renderInput={props => (
        <TextField
          {...props}
          {...textFieldProps}
          helperText={helperText}
          error={error}
        />
      )}
    />
  )
}